<template>
  <BaseCard :width="width">
    <div class="folha" v-if="dadosEvento != null">
      <div slot="header">
        <h3>Beneficiário</h3>
        <br />
      </div>
      <div>
        <table class="table table-bordered" v-if="dadosEvento.dadosCliente">
          <tr>
            <th class="uppercase">Código</th>
            <td>
              {{ dadosEvento.dadosCliente.idProspect }}
              <router-link
                target="_blank"
                :to="`/DetalheAssociado/${dadosEvento.dadosCliente.idProspect}`"
              >
                <feather-icon icon="ExternalLinkIcon" svgClasses="h-4 w-4" />
              </router-link>
            </td>
          </tr>
          <tr>
            <th class="uppercase">Nome</th>
            <td>{{ dadosEvento.dadosCliente.nome }}</td>
          </tr>
          <tr>
            <th class="uppercase">
              {{
                dadosEvento.dadosCliente.tipo == 'Pessoa Física'
                  ? 'CPF'
                  : 'CNPJ'
              }}
            </th>
            <td>{{ dadosEvento.dadosCliente.cpfcnpj }}</td>
          </tr>

          <tr>
            <th class="uppercase">Telefone</th>
            <td>
              {{ dadosEvento.dadosCliente.telefone }}
            </td>
          </tr>
          <tr>
            <th class="uppercase">Celular</th>
            <td>{{ dadosEvento.dadosCliente.celular }}</td>
          </tr>
          <tr>
            <th class="uppercase">Email</th>
            <td>{{ dadosEvento.dadosCliente.email }}</td>
          </tr>
          <tr>
            <th class="uppercase">Status</th>
            <td>
              {{ dadosEvento.dadosCliente.status }}
            </td>
          </tr>
          <tr>
            <th class="uppercase">Data de Cadastro</th>
            <td>
              {{ formataData(dadosEvento.dadosCliente.dataCadastro) }}
            </td>
          </tr>
          <tr>
            <th class="uppercase">{{ $t('Consultor') }}</th>
            <td>
              {{ dadosEvento.dadosCliente.consultor }}
            </td>
          </tr>
          <tr>
            <th class="uppercase">Divisão</th>
            <td>
              {{ dadosEvento.dadosCliente.divisao }}
            </td>
          </tr>
          <tr>
            <th class="uppercase">Regional</th>
            <td>
              {{ dadosEvento.dadosCliente.regional }}
            </td>
          </tr>

          <tr>
            <th class="uppercase">Boletos em aberto</th>
            <td>
              {{ dadosEvento.dadosCliente.boletosEmAberto }}
            </td>
          </tr>
        </table>
      </div>
    </div>
  </BaseCard>
</template>

<script>
import moment from 'moment';
import BaseCard from './BaseCard.vue';

export default {
  props: {
    dadosEvento: {
      type: Object,
    },
    width: {
      type: Number,
      default: 4,
    },
  },
  components: {
    BaseCard,
  },
  methods: {
    formataData(data) {
      if (!data) {
        return '';
      }

      return moment(data).format('DD/MM/YYYY HH:mm');
    },
  },
};
</script>
